import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TouchableOpacity, StyleSheet } from 'react-native';

import Colors from '../constants/Colors';

import { AppText } from './AppText';

class FilledButton extends Component {
  static propTypes = {
    onPress: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    full: PropTypes.bool.isRequired,
    textColor: PropTypes.string,
    disabled: PropTypes.bool,
    heigth: PropTypes.number,
    radius: PropTypes.number,
    paddingHorizontal: PropTypes.number,
    testID: PropTypes.string,
  };

  constructor(props) {
    super();
  }

  render() {
    const {
      onPress,
      label,
      color,
      full,
      textColor,
      backgroundColor,
      disabled,
      height = 48,
      radius,
      paddingHorizontal,
      testID,
    } = this.props;
    const styles = StyleSheet.create({
      button: {
        backgroundColor: backgroundColor ? backgroundColor : full ? color : Colors.white,
        opacity: disabled ? 0.5 : 1,
        borderWidth: full ? 0 : 1,
        borderColor: color,
        borderRadius: radius !== undefined ? radius : height / 2,
        height: height,
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        paddingHorizontal: paddingHorizontal || 0,
      },
      text: {
        color: full ? textColor || Colors.white : color,
        fontSize: 18,
        fontFamily: 'roboto-bold',
      },
    });
    const testIDLabel = testID || `button-${label}` || '';

    return (
      <TouchableOpacity
        onPress={onPress}
        style={styles.button}
        disabled={disabled}
        testID={testIDLabel.toLowerCase()}
      >
        <AppText style={styles.text}>{label}</AppText>
      </TouchableOpacity>
    );
  }
}

export default FilledButton;
